import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

const POINTS = [
  "Professional recruitment team with deep industry expertise",
  "Quality-driven multi-stage hiring process",
  "Compliance-focused payroll & statutory management",
  "Fast turnaround time — 7 to 15 days for most roles",
  "Client-centric, dedicated account management",
  "PAN India recruitment capability across 14+ industries",
];

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWxzJTIwb2ZmaWNlJTIwbWVldGluZ3xlbnwwfHx8fDE3ODI3NTQwMTh8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="Professional HR consulting team meeting"
                loading="lazy"
                className="rounded-3xl shadow-xl w-full object-cover aspect-[4/5] lg:aspect-[4/4.6]"
              />
              <div className="absolute -bottom-6 -right-6 hidden md:block bg-white rounded-2xl shadow-xl p-6 border border-slate-100 max-w-[260px]">
                <div className="font-heading font-extrabold text-4xl text-primary">14+</div>
                <div className="text-sm text-slate-600 mt-1">Industries Served Pan India</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 reveal">
            <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">About Us</p>
            <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
              Your trusted partner for workforce excellence
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Advance HR Technologies is a professional HR & staffing firm headquartered in Maharashtra, serving
              enterprises, SMEs and startups across India. We combine deep recruitment expertise, rigorous compliance,
              and a relentless focus on quality to help our clients build resilient, high-performing teams.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div className="rounded-xl border border-slate-200 p-5 bg-white">
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-primary">Our Mission</p>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  Deliver compliant, scalable workforce solutions that accelerate business outcomes for every client we serve.
                </p>
              </div>
              <div className="rounded-xl border border-slate-200 p-5 bg-white">
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-primary">Our Vision</p>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  To be India's most trusted HR & staffing partner — known for quality, integrity and operational excellence.
                </p>
              </div>
            </div>

            <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-slate-700">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" strokeWidth={1.75} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/about"
              data-testid="about-cta"
              className="mt-9 inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary-hover transition-colors group"
            >
              Learn more about us
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
